module.exports = __webpack_public_path__ + "static/media/ca_working.4f3124ab.png";